import { useState } from 'react';
import SectionReveal from './SectionReveal';

const API_URL = 'https://nwt.am';

export default function ContactSection({ t }) {
  const [formData, setFormData] = useState({ 
    name: '', 
    company: '', 
    phone: '', 
    email: '', 
    projectType: '', 
    message: '' 
  });
  const [status, setStatus] = useState({ type: '', message: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: 'loading', message: '' });

    // === ДЕБАГ: Проверяем, что лежит в formData перед отправкой ===
    console.log('Отправляемые поля из state:', formData);

    try {
      const data = new FormData();
      data.append('name', formData.name);
      data.append('company', formData.company);
      data.append('phone', formData.phone);
      data.append('email', formData.email);
      data.append('projectType', formData.projectType);
      data.append('message', formData.message);

      // Проверим, что FormData реально заполнился
      for (let pair of data.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
      }

      const response = await fetch(`${API_URL}/sendmail.php`, {
        method: 'POST',
        body: data,
      });

      const text = await response.text();
      console.log('Ответ сервера:', text);

      let result;
      try {
        result = JSON.parse(text);
      } catch (err) {
        console.error('Ответ не JSON:', text);
        setStatus({ type: 'error', message: 'Сервер вернул не JSON. Смотри консоль.' });
        return;
      }

      if (response.ok && result.success) {
        setStatus({ type: 'success', message: t?.contactSentSuccess || 'Сообщение отправлено' });
        setFormData({ name: '', company: '', phone: '', email: '', projectType: '', message: '' });
      } else {
        setStatus({ type: 'error', message: result.message || 'Ошибка отправки' });
      }
    } catch (error) {
      console.error('Ошибка fetch:', error);
      setStatus({ type: 'error', message: 'Ошибка соединения.' });
    }

    setTimeout(() => setStatus({ type: '', message: '' }), 5000);
  };

  return (
    <section id="contact" className="relative bg-white px-3 py-16 md:px-10">
      <div className="mx-auto max-w-7xl space-y-12">
        
        {/* Блок 1: Заголовок + описание */}
        <SectionReveal>
          <div className="border-l-4 border-[#0FA4E8] bg-gray-50 p-6 md:p-10">
            <h2 className="text-2xl md:text-4xl font-black text-[#0B3B6F] uppercase mb-3">
              {t?.contactTitle || 'Կապ'}
            </h2>
            <p className="text-lg font-bold text-[#0B3B6F] mb-2">
              {t?.contactHeading || 'Եկեք քննարկենք Ձեր նախագիծը'}
            </p>
            <p className="text-sm md:text-base text-slate-600 leading-relaxed max-w-3xl">
              {t?.contactIntro || ''}
            </p>
          </div>
        </SectionReveal>
        {/* Блок 2: Контакты */}
        <SectionReveal delay={150}>
          <div className="border-l-4 border-[#0B3B6F] bg-gray-50 p-6 md:p-10">
            <h3 className="text-lg font-bold text-[#0B3B6F] uppercase mb-6">
              {t?.companyName || 'National Water Technologies Armenia LLC'}
            </h3>
            <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {/* Адрес */}
              <div className="flex items-start gap-3">
                <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-white border border-gray-200 text-[#0FA4E8]">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                    <circle cx="12" cy="10" r="3"/>
                  </svg>
                </span>
                <div>
                  <p className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">{t?.contactAddressLabel || 'Հասցե'}</p>
                  <p className="text-sm font-semibold text-[#0B3B6F]">{t?.footerAddress || 'Երևան, Հայաստան'}</p>
                </div>
              </div>
              {/* Телефон */}
              <div className="flex items-start gap-3">
                <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-white border border-gray-200 text-[#0FA4E8]">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                  </svg>
                </span>
                <div>
                  <p className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">{t?.contactPhoneLabel || 'Հեռախոս'}</p>
                  <a href="tel:+37477950406" className="text-sm font-semibold text-[#0B3B6F] hover:text-[#0FA4E8] transition-colors">
                  +37495040655
                  </a>
                </div>
              </div>
              {/* Email */}
              <div className="flex items-start gap-3">
                <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-white border border-gray-200 text-[#0FA4E8]">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                </span>
                <div>
                  <p className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">{t?.contactEmailLabel || 'Email'}</p>
                  <a href="mailto:Nwt.arm@gmail.com" className="text-sm font-semibold text-[#0B3B6F] hover:text-[#0FA4E8] transition-colors">
                    Nwt.arm@gmail.com
                  </a>
                  <br />
                  {/* <a href="mailto:info@nwt.am" className="text-sm font-semibold text-[#0B3B6F] hover:text-[#0FA4E8] transition-colors">
                    info@nwt.am
                  </a> */}
                </div>
              </div>
            </div>
            {/* Сайт */}
            <div className="mt-5 flex items-center gap-3">
              <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-white border border-gray-200 text-[#0FA4E8]">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="2" y1="12" x2="22" y2="12"/>
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                </svg>
              </span>
              <div>
                <p className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">www</p>
                <a href="https://www.nwt.am" target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-[#0B3B6F] hover:text-[#0FA4E8] transition-colors">
                  www.nwt.am
                </a>
              </div>
            </div>
          </div>
        </SectionReveal>

        {/* Блок 3: Форма */}
        <SectionReveal delay={300}>
          <div id="call" className="border-l-4 border-[#0FA4E8] bg-gray-50 p-6 md:p-10">
            <h3 className="text-lg font-bold text-[#0B3B6F] uppercase mb-2">
              {t?.contactFormTitle || 'Ուղարկեք մեզ Ձեր հարցումը'}
            </h3>
            <p className="text-sm text-slate-500 mb-6">
              {t?.contactFormSubtitle || ''}
            </p>

            {status.type === 'success' ? (
              <div className="p-6 bg-green-50 border border-green-200 text-green-700 font-semibold text-center text-sm">
                ✓ {status.message}
              </div>
            ) : (
              <>
                {status.type === 'error' && (
                  <div className="p-6 bg-red-50 border border-red-200 text-red-700 font-semibold text-center text-sm mb-4">
                    {status.message}
                  </div>
                )}
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="grid gap-4 sm:grid-cols-2">
                    <div>
                      <label className="block text-xs font-bold text-[#0B3B6F] uppercase tracking-wider mb-1.5">
                        {t?.contactLabelName || 'Անուն / Ազգանուն'}
                      </label>
                      <input 
                        type="text" required
                        value={formData.name}
                        onChange={(e) => setFormData({...formData, name: e.target.value})}
                        placeholder={t?.contactPlaceholderName || 'Ձեր անունը'}
                        className="w-full border border-gray-200 bg-white px-4 py-3 text-sm text-[#0B3B6F] placeholder:text-slate-400 focus:outline-none focus:border-[#0FA4E8] transition-colors"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-bold text-[#0B3B6F] uppercase tracking-wider mb-1.5">
                        {t?.contactLabelCompany || 'Ընկերություն / Կազմակերպություն'}
                      </label>
                      <input 
                        type="text"
                        value={formData.company}
                        onChange={(e) => setFormData({...formData, company: e.target.value})}
                        placeholder="Ընկերության անվանումը"
                        className="w-full border border-gray-200 bg-white px-4 py-3 text-sm text-[#0B3B6F] placeholder:text-slate-400 focus:outline-none focus:border-[#0FA4E8] transition-colors"
                      />
                    </div>
                  </div>
                  <div className="grid gap-4 sm:grid-cols-2">
                    <div>
                      <label className="block text-xs font-bold text-[#0B3B6F] uppercase tracking-wider mb-1.5">
                        {t?.contactLabelPhone || 'Հեռախոս'}
                      </label>
                      <input 
                        type="tel" required
                        value={formData.phone}
                        onChange={(e) => setFormData({...formData, phone: e.target.value})}
                        placeholder={t?.contactPlaceholderPhone || '+374 XX XXXXXX'}
                        className="w-full border border-gray-200 bg-white px-4 py-3 text-sm text-[#0B3B6F] placeholder:text-slate-400 focus:outline-none focus:border-[#0FA4E8] transition-colors"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-bold text-[#0B3B6F] uppercase tracking-wider mb-1.5">
                        {t?.contactLabelEmail || 'Էլ. փոստ'}
                      </label>
                      <input 
                        type="email" required
                        value={formData.email}
                        onChange={(e) => setFormData({...formData, email: e.target.value})}
                        placeholder={t?.contactPlaceholderEmail || 'example@mail.com'}
                        className="w-full border border-gray-200 bg-white px-4 py-3 text-sm text-[#0B3B6F] placeholder:text-slate-400 focus:outline-none focus:border-[#0FA4E8] transition-colors"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-xs font-bold text-[#0B3B6F] uppercase tracking-wider mb-1.5">
                      {t?.contactLabelProjectType || 'Նախագծի տեսակը'}
                    </label>
                    <select 
                      value={formData.projectType}
                      onChange={(e) => setFormData({...formData, projectType: e.target.value})}
                      className="w-full border border-gray-200 bg-white px-4 py-3 text-sm text-[#0B3B6F] focus:outline-none focus:border-[#0FA4E8] transition-colors"
                    >
                      <option value="">{t?.contactSelectProject || ''}</option>
                      <option value="municipal">{t?.contactOptMunicipal || ''}</option>
                      <option value="industrial">{t?.contactOptIndustrial || ''}</option>
                      <option value="drinking">{t?.contactOptDrinking || ''}</option>
                      <option value="local">{t?.contactOptLocal || ''}</option>
                      <option value="other">{t?.contactOptOther || ''}</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-xs font-bold text-[#0B3B6F] uppercase tracking-wider mb-1.5">
                      {t?.contactLabelMessage || 'Հաղորդագրություն'}
                    </label>
                    <textarea 
                      rows="5" required
                      value={formData.message}
                      onChange={(e) => setFormData({...formData, message: e.target.value})}
                      placeholder={t?.contactPlaceholderMessage || ''}
                      className="w-full border border-gray-200 bg-white px-4 py-3 text-sm text-[#0B3B6F] placeholder:text-slate-400 focus:outline-none focus:border-[#0FA4E8] transition-colors resize-none"
                    ></textarea>
                  </div>

                  <button 
                    type="submit"
                    disabled={status.type === 'loading'}
                    className="w-full bg-[#0FA4E8] hover:bg-[#0B3B6F] disabled:opacity-50 disabled:cursor-not-allowed text-white font-bold py-3.5 uppercase tracking-wider text-sm transition-colors"
                  >
                    {status.type === 'loading' ? 'Ուղարկվում է...' : (t?.contactButtonSend || 'Ուղարկել հարցումը')}
                  </button>
                </form>
              </>
            )}
          </div>
        </SectionReveal>

        {/* Блок 4: Сотрудничество */}
        <SectionReveal delay={450}>
          <div className="border-l-4 border-[#0B3B6F] bg-gray-50 p-6 md:p-10">
            <h3 className="text-lg font-bold text-[#0B3B6F] uppercase mb-4">
              {t?.contactCooperationTitle || ''}
            </h3>
            <p className="text-sm md:text-base text-slate-600 leading-relaxed mb-6">
              {t?.contactCooperationText || ''}
            </p>
            <p className="text-lg font-bold text-[#0B3B6F] leading-relaxed">
              {t?.contactCooperationTagline || ''}
            </p>
          </div>
        </SectionReveal>

      </div>
    </section>
  );
}